import { ColumnRawData } from '@bingads-webui-grid/well-known';

export const ListingGroupColumn: ColumnRawData = {
  key: 'ListingGroup',
  name: _TL_('Listing group'),
};

/**
 * @deprecated
 */
export const AssetGroupColumn: ColumnRawData = {
  key: 'AssetGroup',
  name: _TL_('Asset group'),
};

export const AssetGroupNameColumn: ColumnRawData = {
  key: 'AssetGroupName',
  name: _TL_('Asset group'),
};

export const ListingColumn: ColumnRawData = {
  key: 'Listing',
  name: _TL_('Products'),
};

export const IncludeExcludeColumn: ColumnRawData = {
  key: 'IncludeExclude',
  name: _TL_('Inclusion'),
};
